import type { BookLibrary } from "../models/types";

/** Demo library for testMode when no data exists in localStorage */
export function createDemoLibrary(): BookLibrary {
  return {
    version: 1,
    lastModified: new Date().toISOString(),
    books: [
      {
        id: "demo-01",
        title: "Dune",
        author: "Frank Herbert",
        datePublished: "1965",
        status: "read",
        rating: 5,
        series: "Dune",
        seriesNumber: "1",
        recommendations: [{ from: "Patrick", comment: "A must-read classic" }],
        dateAdded: "2024-01-01T00:00:00.000Z",
        dateStarted: "2024-01-05",
        dateRead: "2024-01-28",
        notes: "The spice must flow.",
        coverUrl:
          "https://covers.openlibrary.org/b/id/12467622-M.jpg",
      },
      {
        id: "demo-02",
        title: "Neuromancer",
        author: "William Gibson",
        datePublished: "1984",
        status: "read",
        rating: 4,
        series: "Sprawl",
        seriesNumber: "1",
        recommendations: [],
        dateAdded: "2024-01-02T00:00:00.000Z",
        dateStarted: "2024-02-01",
        dateRead: "2024-02-18",
        coverUrl:
          "https://covers.openlibrary.org/b/id/14350216-M.jpg",
      },
      {
        id: "demo-03",
        title: "The Left Hand of Darkness",
        author: "Ursula K. Le Guin",
        datePublished: "1969",
        status: "read",
        rating: 5,
        recommendations: [{ from: "Sarah", comment: "Beautiful and strange" }],
        dateAdded: "2024-01-03T00:00:00.000Z",
        dateRead: "2024-03-10",
        coverUrl:
          "https://covers.openlibrary.org/b/id/12780928-M.jpg",
      },
      {
        id: "demo-04",
        title: "Project Hail Mary",
        author: "Andy Weir",
        datePublished: "2021",
        status: "reading",
        recommendations: [{ from: "Mike", comment: "You won't put it down" }],
        dateAdded: "2024-02-01T00:00:00.000Z",
        dateStarted: "2024-06-01",
        coverUrl:
          "https://covers.openlibrary.org/b/id/10541286-M.jpg",
      },
      {
        id: "demo-05",
        title: "Foundation",
        author: "Isaac Asimov",
        datePublished: "1951",
        series: "Foundation",
        seriesNumber: "1",
        status: "read",
        rating: 4,
        recommendations: [],
        dateAdded: "2024-01-05T00:00:00.000Z",
        dateRead: "2023-11-15",
        coverUrl:
          "https://covers.openlibrary.org/b/id/6501067-M.jpg",
      },
      {
        id: "demo-06",
        title: "The Hitchhiker's Guide to the Galaxy",
        author: "Douglas Adams",
        datePublished: "1979",
        series: "Hitchhiker's Guide",
        seriesNumber: "1",
        status: "read",
        rating: 5,
        recommendations: [],
        dateAdded: "2024-01-06T00:00:00.000Z",
        dateRead: "2023-08-20",
        coverUrl:
          "https://covers.openlibrary.org/b/id/12689038-M.jpg",
      },
      {
        id: "demo-07",
        title: "Snow Crash",
        author: "Neal Stephenson",
        datePublished: "1992",
        status: "reading",
        recommendations: [],
        dateAdded: "2024-03-01T00:00:00.000Z",
        dateStarted: "2024-06-10",
        coverUrl:
          "https://covers.openlibrary.org/b/id/519627-M.jpg",
      },
      {
        id: "demo-08",
        title: "Hyperion",
        author: "Dan Simmons",
        datePublished: "1989",
        series: "Hyperion Cantos",
        seriesNumber: "1",
        status: "want-to-read",
        recommendations: [{ from: "Alex", comment: "Space Canterbury Tales" }],
        dateAdded: "2024-04-01T00:00:00.000Z",
        coverUrl:
          "https://covers.openlibrary.org/b/id/12744057-M.jpg",
      },
      {
        id: "demo-09",
        title: "The Name of the Wind",
        author: "Patrick Rothfuss",
        datePublished: "2007",
        series: "The Kingkiller Chronicle",
        seriesNumber: "1",
        status: "want-to-read",
        recommendations: [{ from: "Jenna", comment: "Best fantasy prose ever" }],
        dateAdded: "2024-04-15T00:00:00.000Z",
        coverUrl:
          "https://covers.openlibrary.org/b/id/14368850-M.jpg",
      },
      {
        id: "demo-10",
        title: "Ringworld",
        author: "Larry Niven",
        datePublished: "1970",
        status: "want-to-read",
        recommendations: [],
        dateAdded: "2024-05-01T00:00:00.000Z",
        coverUrl:
          "https://covers.openlibrary.org/b/id/6654691-M.jpg",
      },
    ],
  };
}
